import { apiClientV1 } from './apiClient';

export default {
  // 'video', 'playlist', 'videoLink', 'playlistLink'
  getBrandingSettings: ({ id, ...params }) => apiClientV1.get(`/video/branding/${id}`, { params }),
  saveVideoBrandingSettings: (params) => apiClientV1.post('/video/save-branding', { ...params })
};
